module.exports = __webpack_public_path__ + "img/empty.65bca139.png";